import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {catchError, mergeMap} from 'rxjs/operators';
import {from, of} from 'rxjs';
import {LoadError} from '@app/core/store/actions/error.actions';
import {
	EFileEntryActions,
	GetFileEntries, GetFileEntriesSuccess,
	GetFileEntry,
	GetFileEntrySuccess,
	PostFileEntries,
	PostFileEntriesSuccess,
} from '@app/core/store/actions/file-entry.actions';
import {HttpService} from '@app/core/services/http.service';
import {FileEntryService} from '@app/modules/shared/services/fileEntry.service';
import {FileEntry} from '@app/core/models/fileEntry.model';

@Injectable()
export class FileEntryEffects {

	@Effect()
	public onPostFileEntry$ = this.actions$.pipe(
		ofType<PostFileEntries>(EFileEntryActions.PostFileEntries),
		mergeMap((action: PostFileEntries) => from(this.fileEntryService.uploadFiles(action.files)).pipe(
			mergeMap((fileEntries: FileEntry[]) => [
				new PostFileEntriesSuccess(fileEntries)
			]),
			catchError(error => of(new LoadError(error, action))),
		)),
	);

	@Effect()
	public onGetFileEntry$ = this.actions$.pipe(
		ofType<GetFileEntry>(EFileEntryActions.GetFileEntry),
		mergeMap((action: GetFileEntry) => from(this.fileEntryService.getFileEntryObs(action.id)).pipe(
			mergeMap((fileEntry: FileEntry) => [
				new GetFileEntrySuccess(fileEntry),
			]),
			catchError(error => of(new LoadError(error, action))),
		)),
	);

	@Effect()
	public onGetFileEntries$ = this.actions$.pipe(
		ofType<GetFileEntries>(EFileEntryActions.GetFileEntries),
		mergeMap((action: GetFileEntries) => from(this.fileEntryService.getFileEntries(action.page, action.pageSize, action.isNotAttached)).pipe(
			mergeMap((res: any) => [
				new GetFileEntriesSuccess(res.data, res.pagination),
			]),
			catchError(error => of(new LoadError(error, action))),
		)),
	);

	constructor(
		private actions$: Actions,
		private httpService: HttpService,
		private fileEntryService: FileEntryService,
	) {
	}
}
